import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72fffff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "load-report-form-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "load-report-form-title" }, "Загрузка отчёта", -1))
const _hoisted_3 = { class: "load-report-form-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    isShowBodyCloseButton: true,
    visible: true,
    "body-style": "padding: 24px;",
    style: {"width":"780px"},
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
  }, {
    body: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("input", {
          name: "file",
          type: "file",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelectFile && _ctx.onSelectFile(...args)))
        }, null, 32),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ButtonComponent, {
            disabled: Boolean(!_ctx.data.file),
            class: "form-button",
            "data-type": "accent",
            onClick: _ctx.onUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Загрузить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}